import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexTitleSubtitle,
  ApexLegend,
  ChartComponent,
  ApexMarkers
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  markers: ApexMarkers;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  legend: ApexLegend;
};

@Component({
  selector: 'app-grafica-lineal',
  templateUrl: './grafica-lineal.component.html',
  styleUrl: './grafica-lineal.component.css'
})
export class GraficaLinealComponent implements OnInit {
  @ViewChild('chart')
  chart!: ChartComponent;

  @Input() DatosGraf: any = [];
  @Input() name: string = '';
  @Input() indicadorId: number;

  public chartOptions: Partial<ChartOptions>;

  constructor() { }

  ngOnInit(): void {
    const labels: string[] = [];
    const dataMeta: number[] = [];
    const dataReal: number[] = [];

    for (const dat of this.DatosGraf) {
      labels.push(dat[0]);
      dataMeta.push(dat[1]);
      dataReal.push(dat[2]);
    }

    const valores = [...dataMeta, ...dataReal];

    const min = Math.min(...valores);
    const max = Math.max(...valores);

    this.chartOptions = {
      series: [
        {
          name: 'Meta',
          data: dataMeta
        },
        {
          name: 'Real',
          data: dataReal
        }
      ],
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        }
      },

      // Mostrar el valor en cada punto
      dataLabels: {
        enabled: true,
        offsetY: -8,
        style: {
          fontSize: '10px'
        }
      },

      // Grosor y tipo de línea
      stroke: {
        curve: 'smooth',
        width: 2 // Puedes poner 1, 2, 3...
      },

      // Círculos en cada punto
      markers: {
        size: 6,
        strokeWidth: 2,
        colors: ['white'],
        strokeColors: ['#008FFB', '#00E396'], // color del contorno de cada serie
        hover: {
          size: 7
        }
      },

      title: {
        text: this.name,
        align: 'center'
      },

      legend: {
        position: 'bottom'
      },

      xaxis: {
        categories: labels
      },

      yaxis: {
        min: Math.max(0, min - 5),
        max: max + 5,
        tickAmount: 5
      }
    };
  }

  public async obtenerImagen(): Promise<string> {
    const result = await this.chart.dataURI();

    if ('imgURI' in result) {
      return result.imgURI;
    }

    throw new Error('No fue posible obtener la imagen.');
  }
}
